
import { map, catchError } from 'rxjs/operators';
import { Injectable } from "@angular/core";



import { Observer } from "rxjs";
import { Observable } from "rxjs/internal/Observable";


import * as JWT from 'jwt-decode';

import { resolve } from 'url';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { AppState } from '../reducers';
import { Logout } from '../auth';
import { environment } from '../../../environments/environment';
import { WebApiService } from './WebApiService';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'my-auth-token'
    })
};

@Injectable()
export class UserService {
    logout() {

        //corrigir
        //  this.store.dispatch(new Logout());
    }


    login(loginData: any) {


        return this.http.post(this.webApi.GetApiAddress() + '/ApplicationUser/Login', loginData, httpOptions);

    }


    setCurrentUserEmail(email: string) {

        //this.cookieService.set("simulatingUserEmail", email)


    }

    getCurrentUserEmailX(withoutEmulated: boolean = false): any {

        let idToken: string;

        if (this.idToken != null) {
            idToken = this.idToken;
        }
        else {
            idToken = this.idToken = localStorage.getItem(environment.authTokenKey);
        }

        let email = JWT(idToken)['Email'];


        return email;
    }

    isSimulateUserEmail(): any {
        let idToken: string;

        if (this.idToken != null) {
            idToken = this.idToken;
        }
        else {
            idToken = this.idToken = localStorage.getItem(environment.authTokenKey);
        }

        return false;
    }

    getCurrentUserId(withoutEmulated: boolean = false): string {


        let idToken: string;


        idToken = this.idToken = localStorage.getItem(environment.authTokenKey);

        let jwt = JWT(idToken);

        let userId = jwt['UserID'];


        return userId;
    }



    idToken: any;
    public authMode: number = 0;

    constructor(private http: HttpClient, private webApi: WebApiService, private store: Store<AppState>,) {
    }

    //, private cookieService: CookieService
  isUserLogged(): Promise<boolean> {
    return this.http.get(this.webApi.GetApiAddress() + '/Users/IsLogged', httpOptions)
        .toPromise()
        .then(() => true)
        .catch((err) => {
            console.log("Erro ao verificar login:", err);
            return false;
        });
}

    getOrCreateMachineId(): string {
        const cookieName = 'machine_id';
        let machineId = this.getCookie(cookieName);
        if (!machineId) {
            machineId = this.generateUUID();
            this.setCookie(cookieName, machineId, 365); // válido por 1 ano
        }
        return machineId;
    }
    generateUUID(): string {
        return crypto.randomUUID(); // disponível em navegadores modernos
    }
    setCookie(name: string, value: string, days: number) {
        const expires = new Date(Date.now() + days * 864e5).toUTCString();
        document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax`;
    }
    getCookie(name: string): string | null {
        const cookies = document.cookie.split('; ');
        const match = cookies.find(c => c.startsWith(name + '='));
        return match ? decodeURIComponent(match.split('=')[1]) : null;
    }

getAuth(): { email: string, userId: string, grants: string } | null {
    let idToken = this.idToken ?? localStorage.getItem(environment.authTokenKey);
    if (!idToken) return null;

    try {
        const jwt: any = JWT(idToken);
        return {
            email: jwt['Email'],
            userId: jwt['UserID'],
            grants: jwt['Grants']?.toLowerCase() || 'user' // transforma em lowercase para padronizar
        };
    } catch (e) {
        console.error("Erro ao decodificar token:", e);
        return null;
    }
}

    verifyold2(url: string) {

        let result: boolean = false;

        if (this.authMode == 0) {
            if (this.idToken != null) {
                result = true;
            }
            else {
                if (localStorage.getItem(environment.authTokenKey) != null) {
                    this.idToken = localStorage.getItem(environment.authTokenKey);
                    result = true;
                }
            }



            this.http.get(this.webApi.GetApiAddress() + `/Users/IsLogged`, httpOptions)
                .pipe(
                    map(result => {



                    }


                    ), catchError(errorx => {

                        return errorx;
                    })).toPromise().then(
                        data => {
                            console.log("Verificando permissão");
                            console.log(data);
                        }

                    );



            // if (result && url.indexOf("/admins") == 0) {


            //     if (this.getCurrentUserEmailX(true) != "cze@spolti.com.br") {
            //         result = false;

            //     }
            // }

            return result;


        }

    }

    // verifyOld() {

    //     return this.http.get('/api/verify', this.jwt()).pipe(map((response: Response) => response.json()));
    // }

    //     forgotPassword(email: string): Promise<void> {


    //    //     return new Promise<void>();
    //      //arrumar 
    //         // var emailAddress = email;

    //         // return auth.sendPasswordResetEmail(emailAddress).then(function () {

    //         //});

    //         // .catch(function(error) {
    //         //   // An error happened.
    //         // });

    //         // return firebase.auth().for

    //       //   return this.http.post('/api/forgot-password', JSON.stringify({ email }), this.jwt()).pipe(map((response: Response) => response.json())).toPromise();
    //     }




}